(function () {
    'use strict';

    angular
        .module('travelExpenses')
        .controller('DailyAllowanceFormModalController', DailyAllowanceFormModalController);

        DailyAllowanceFormModalController.$inject = ['$uibModalInstance', 'TravelExpenseService', 'dailyAllowanceController', 'toastr', 'sellers', 'expos', 'currencies'];

    function DailyAllowanceFormModalController($uibModalInstance, TravelExpenseService, dailyAllowanceController, toastr, sellers, expos, currencies) {
        var vm = this;

        vm.sellerSelected = '';
        vm.expoSelected = '';
        vm.currencySelected = '';
        vm.amount = '';
        vm.days = '';

        vm.currencies = currencies;

        vm.sellers = [];
        angular.copy(sellers, vm.sellers);
        vm.sellers.splice(0,1);

        vm.expos = [];
        angular.copy(expos, vm.expos);
        vm.expos.splice(0,1);
        
        vm.ok = ok;
        vm.cancel = cancel;

        activate();

        function activate() {
        }

        function ok () {
            let query = {};
            query['seller_id'] = vm.sellerSelected;
            query['expo_id'] = vm.expoSelected;
            query['currency'] = vm.currencySelected;
            query['amount'] = vm.amount;
            query['days'] = vm.days;
            TravelExpenseService.saveDailyAllowance(query).then(function(response, status) {
                if(response.status !== 200 && response.status !== 201) {
                    toastr.error("An error ocurred on save this daily allowance");
                } else {
                    toastr.success("Daily allowance successfully saved!");
                    dailyAllowanceController.getByFilter();
                }
                $uibModalInstance.close();
            }).catch(function(err) {
                toastr.error('Error:'+err);
            });
        }

        function cancel () {
            $uibModalInstance.close();
        }
    }
})();